/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect, useState } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function ImporterProfile() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const { importerProfileValue, importerProfileComment } = countryBrandApplication;

	const [importer, setImporter] = useState(!importerProfileValue || importerProfileValue === "SI");

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const importerProfileValue = formElement.elements.importProfile.value;
			const importerProfileComment = formElement.elements.comment?.value ?? "";

			update({
				data: {
					importerProfileValue,
					importerProfileComment,
				},
				nextStep: currentStep + 1,
			});
		}
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	function handleChange() {
		formRef.current.elements.importProfile.value === "SI" ? setImporter(true) : setImporter(false);
	}

	return (
		<div className="step-page" id="step-9">
			<section>
				<h3>9 - Perfil Importador - ¿Importa bienes o servicios actualmente?</h3>
				<select name="importProfile" defaultValue={importerProfileValue} onChange={handleChange}>
					<option value="SI">SI</option>
					<option value="NO">NO</option>
				</select>
				{importer && (
					<label htmlFor="comment">
						Describa a continuación los bienes y/o servicios importados por su empresa *
						<textarea rows="6" name="comment" defaultValue={importerProfileComment} required />
					</label>
				)}
			</section>
		</div>
	);
}

export { ImporterProfile };
